<template>
	<div>
		<div class="nav-buttons-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Buyback Questions</h1>
			<v-base-nav-page :links="links" :nosearch="true">
			</v-base-nav-page>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import 'vuetify/dist/vuetify.min.css';
	import BaseNavPage from './../components/BaseNavPage';
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "BuybackQuestions",

		components: {
			BaseNavLinks,
			'v-base-nav-page': BaseNavPage,
		},

		data() {
			return {
				links: [
					{
						to: '/how_i_can_get_paid_for_book',
						caption: 'How can I get paid for my book?'
					},
					{
						to: '/how_long_does_it_take_for_me_to_get_paid',
						caption: 'How long does it take for me to get paid?'
					},
				]
			}
		},

		mounted() {
			const self = this;
		}
	}
</script>

<style scoped>

</style>